import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import type { components } from 'api/playerPayback/api'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

interface PatronSweepstakeEntriesParams {
  patronId: number
  licensedEstablishmentId: number
}

export const useGetExpiredPatronSweepstakeEntries = ({
  patronId,
  licensedEstablishmentId,
}: PatronSweepstakeEntriesParams): UseQueryResult<
  Array<components['schemas']['FullSweepstakeEntriesDTO']>
> => {
  const get = useTypedApiClient({
    path: '/admin/patron/sweepstake-entries/expired/{patronId}/{licensedEstablishmentId}',
    method: 'get',
  })

  return useQuery({
    queryKey: [
      '/admin/patron/sweepstake-entries/expired',
      patronId,
      licensedEstablishmentId,
    ],
    queryFn: async () => {
      const { data } = await get({ patronId, licensedEstablishmentId })
      return data
    },
  })
}
